export function setProperty(el, key, value) {
  el?.style?.setProperty?.(key, value)
}

export function setAttribute(el, key, value) {
  el?.setAttribute?.(key, value)
}

export function removeAttribute(el, key) {
  el?.removeAttribute?.(key)
}

export function observeResize(el, onResize) {
  if (!el) return
  const resizeObserver = new ResizeObserver(entries => {
    for (const entry of entries) {
      const { target, contentBoxSize } = entry
      if (contentBoxSize) {
        const { inlineSize: isize, blockSize: bsize } = entry.contentBoxSize[0]
        onResize({ isize, bsize, target })
      }
    }
  })
  resizeObserver.observe(el)

  return () => {
    resizeObserver.disconnect()
  }
}

export function rafDelay(fn = null) {
  if (!process.browser || !fn) return
  window.requestAnimationFrame(function () {
    window.requestAnimationFrame(function () {
      fn()
    })
  })
}

function getCurrentUrl() {
  return new URL(process.browser ? global.location.href : "https://www.rolex.com")
}

export function getSelected(k, all = "all") {
  const currentUrl = getCurrentUrl()
  const params = currentUrl.searchParams
  return params.get(k) ?? all
}

export function setSelected(p, console) {
  const currentUrl = getCurrentUrl()
  const params = currentUrl.searchParams

  p.forEach(({ k, v }) => {
    let remove = false
    switch (k) {
      case PARAM_KEY_CATEGORY:
        if (v === "all") remove = true
        break
      case PARAM_KEY_FILTER:
        if (v === "all") remove = true
        break
      case PARAM_KEY_RANGE:
        if (v === 0) remove = true
        break
      default:
        break
    }
    if (remove) params.delete(k)
    else params.set(k, v)
  })
  return currentUrl.href
}

export const PARAM_KEY_CATEGORY = "category"
export const PARAM_KEY_FILTER = "filter"
export const PARAM_KEY_RANGE = "range"
export const FILTER_SEPERATOR = ","
export const COL_MAPPING = ["450", "768", "1368", "1920", "2560"]
export const GRID_ROWSPAN_FIRST = 2
export const GRID_SEQUENCE = [2, 1]
export const CN_ACTIVE = "sg-active"
export const CN_DISABLED = "sg-disabled"
export const OPACITY_DURATION_OUT = 200
export const OPACITY_DURATION_IN = 0
export const RANGE_INC = 25
